import { NavItem } from './nav-item';

export class LocationNavItem extends NavItem {}
